import ModifierSet from 'src/models/modifier-set/ModifierSet'
// Modifier Sets have modifiers as a reference. Therefore the modifier collection is missing functionality
// expected by the model table.
// This is a temporary class to provide the missing functionality.
export default class ModifierCollection extends ModifierSet {
  static name = 'ModifierCollection'

  // Ignore displayOrder sorting to respect the order passed to the constructor
  static ignoreDisplayOrder = true

  constructor (data, parent, options = {}) {
    super(data, {
      ...options,
      isCollection: true,
      parent
    })
  }

  get humanCollectionName () {
    return 'Modifiers'
  }

  get humanTypeName () {
    return 'Modifier'
  }

  get modelTypeName () {
    return 'Modifier'
  }
}
